import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'report-inventory-detail',
    templateUrl: './report-inventory-detail.component.html'
})
export class ReportInventoryDetailComponent implements OnInit {
    public product: any;
    public amountChartData: any = [{ data: [], label: "" }];
    public amountChartLabels: any = [];
    public amountChartOptions: any = {
        tooltips: {callbacks: {label: (tooltipItem, data) => {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
                label += ': ';
            }
            label += this.decimal.transform(parseFloat(tooltipItem.yLabel), '1.2-2') + ' KG';
            return label;
        }}},
        responsive: true,
        scales: {
            yAxes: [{
                ticks: {
                    callback: (value, index, values) => {
                        return this.decimal.transform(value, '1.0-0') + ' KG';
                    },
                    min: 0
                }
            }]
        }
    };
    public amountColorOptions: any = [{
        backgroundColor: '',
        borderColor: ''
    }];
    public amountChartType: string = 'bar';
    public start_date: any;
    public end_date: any;

    constructor(private router: Router, private route: ActivatedRoute, private currency: CurrencyPipe, private decimal: DecimalPipe) { }

    ngOnInit() {
        let data = this.route.snapshot.data;
        this.product = data.product;
        this.amountChartData[0].label = "Inventario (KG)";
        this.amountColorOptions[0].backgroundColor = 'rgba(' + this.product.color + ', 0.8)';
        this.amountColorOptions[0].borderColor = 'rgba(' + this.product.color + ', 1)';

        this.product.batch_products.forEach(function(batch_product, i) {
            this.amountChartData[0].data.push(batch_product.amount);
            this.amountChartLabels.push(batch_product.batch.code);
        }, this);
    }

}
